const getters = {
  userName: state => state.app.userName,
  userToken: state => state.app.userToken
}
export default getters
